import { createSlice } from '@reduxjs/toolkit';

const postSlice = createSlice({
  name: 'post',
  initialState: {
    selected: {},
    viewId: 0,
  },
  reducers: {
    setSelectedPost(state, action) {
      state.selected = action.payload;
    },
    clearSelectedPost(state) {
      state.selected = {};
    },
    updateSelectedPost(state, action) {
      state.selected = { ...state.selected, ...action.payload };
    },
    reloadPosts(state) {
      state.viewId += 1;
    },
  },
});

export const {
  clearSelectedPost,
  reloadPosts,
  setSelectedPost,
  updateSelectedPost,
} = postSlice.actions;

export const selectSelectedPost = state => state.post.selected;
export const selectPostsViewId = state => state.post.viewId;

export default postSlice.reducer;
